<template>
  <div class="page-stripes" :class="'page-stripes--' + side" aria-hidden="true">
    <span
      v-for="(stripe, index) in stripes"
      :key="index"
      class="page-stripes__bar"
      :style="{ width: stripe.width + 'px', backgroundColor: stripe.color }"
    />
  </div>
</template>

<script>
export default {
  name: "PageStripes",
  props: {
    side: {
      type: String,
      default: "left",
    },
    colors: {
      type: Array,
      required: true,
    },
    widths: {
      type: Array,
      default: null,
    },
  },
  computed: {
    stripes() {
      const defaultWidths = [10, 7, 5, 2, 0];
      return this.colors.map((color, index) => ({
        color,
        width: this.widths
          ? this.widths[index]
          : defaultWidths[index % defaultWidths.length],
      }));
    },
  },
};
</script>

<style scoped lang="scss">
.page-stripes {
  position: fixed;
  top: 51px;
  bottom: 0;
  display: flex;
  gap: 4px;
  pointer-events: none;
  z-index: 0;
}

.page-stripes--left {
  left: 0;
}

.page-stripes--right {
  right: 0;
}

.page-stripes__bar {
  height: 100%;
}

@media (max-width: 768px) {
  .page-stripes {
    display: none;
  }
}
</style>
